import React from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function FaqEdit() {
    const { id_faq } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = React.useState({
        pertanyaan: "",
        jawaban: "",
    });

    // function "fetchData"
    const fetchData = React.useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/faqs/readFaqById/${id_faq}`);
            // get response data
            const data = response.data;
            // assign response data to state "formValue"
            setFormValue({
                pertanyaan: data.pertanyaan,
                jawaban: data.jawaban,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id_faq]);

    React.useEffect(() => {
        // call method "fetchData"
        fetchData();
    }, [fetchData, id_faq]);

    const handleChange = (event) => {
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // store the states in the form data
        const updatedData = {
            pertanyaan: formValue.pertanyaan,
            jawaban: formValue.jawaban,
        };

        try {
            // make axios put request
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/faqs/updateFaq/${id_faq}`,
                updatedData,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/faq");
        } catch (error) {
            console.error("Error updating data:", error);
            if (error.response) {
                alert(`Error: ${error.response.data.message}`);
            } else {
                alert("Terjadi kesalahan saat menyimpan data.");
            }
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Faq</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Faq</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit FAQ</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Pertanyaan</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="pertanyaan"
                                                        placeholder="Masukkan pertanyaan"
                                                        onChange={handleChange}
                                                        value={formValue.pertanyaan}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Jawaban</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="jawaban"
                                                        placeholder="Masukkan jawaban"
                                                        onChange={handleChange}
                                                        value={formValue.jawaban}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/faq">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default FaqEdit;
